'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Col = exports.Row = undefined;

var _row = require('./row');

var _row2 = _interopRequireDefault(_row);

var _col = require('./col');

var _col2 = _interopRequireDefault(_col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Row = _row2["default"];
exports.Col = _col2["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./components/layout/index.tsx
 ** module id = 82
 ** module chunks = 0
 **/